import { atom } from "jotai";

import {
  DiningBookingWizardCurrentStepAtom,
  DiningBookingWizardListOfStepsAtom,
} from "../../stores";

export const goToPreviousDiningStepAtom = atom(null, (get, set) => {
  const steps = get(DiningBookingWizardListOfStepsAtom);
  const currentStep = get(DiningBookingWizardCurrentStepAtom);

  if (!currentStep || steps.length === 0) {
    return;
  }

  const currentIndex = steps.indexOf(currentStep);
  const isFirstStep = currentIndex <= 0;

  if (isFirstStep) {
    return;
  }

  const previousStep = steps[currentIndex - 1];
  set(DiningBookingWizardCurrentStepAtom, previousStep);
});
